import { MultilingualText } from "@features/events/types";
import i18n from "@shared/i18n/i18n";

/**
 * Safely gets a localized text value from a MultilingualText object.
 * Automatically uses the current language from i18n if not specified.
 * Falls back to the first available language if the requested language is not found.
 * 
 * @param text - The multilingual text object
 * @param language - Optional language code to retrieve. Defaults to current i18n language
 * @returns The localized string or empty string if not found
 */
export const getLocalizedText = (text: MultilingualText | undefined, language?: string): string => {
  if (!text) return "";
  const lang = language ?? i18n.language;
  return text[lang] ?? Object.values(text) ?? "";
};

